import { THEME_WISHLIST_UPDATED } from 'events';
import Wishlist from 'lib/wishlist';
import { component } from 'picoapp';
import { heart, heartFilled } from 'utils/icons';
import { clear, stringToNode } from 'utils/node';

export default component(async (node, ctx) => {
  const PRODUCT_FORM_SELECTOR = '[data-product-form]';
  const { handle } = node.dataset;

  const setIcon = (initial = false) => {
    clear(node);

    if (Wishlist.getItemIndex(handle) > -1) {
      node.innerHTML = heartFilled;

      if (!initial) {
        const pulse = stringToNode(heartFilled);
        pulse.classList.add(
          'animate-ping-once',
          'absolute',
          'top-1/2',
          'left-1/2',
          'transform',
          '-translate-x-1/2',
          '-translate-y-1/2',
          'origin-bottom-right',
        );
        node.appendChild(pulse);
      }
    } else {
      node.innerHTML = heart;
    }
  };

  setIcon(true);

  node.addEventListener('click', (event) => {
    event.stopPropagation();
    event.preventDefault();

    let id = null;
    const form = node.closest(`:has(${PRODUCT_FORM_SELECTOR})`)?.querySelector(PRODUCT_FORM_SELECTOR);

    if (form) {
      const formData = new FormData(form);
      id = formData.get('id');
    }

    Wishlist.toggle(handle, id);
    setIcon();
    ctx.emit(THEME_WISHLIST_UPDATED, { wishlist: Wishlist.items });
  });
});
